import { useState } from "preact/hooks";
import { ApiError, uploadAsset, type AssetInfo } from "../net/api";
import { $panel } from "../state/stores";
import { precheckGLB, type Precheck } from "../upload/precheck";
import { describeError } from "./errors";
import { Panel } from "./Panel";
import { refreshMyAssets } from "../state/myAssets";

export function UploadPanel() {
  const [file, setFile] = useState<File | null>(null);
  const [name, setName] = useState("");
  const [check, setCheck] = useState<Precheck | null>(null);
  const [progress, setProgress] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<AssetInfo | null>(null);

  async function pick(f: File | undefined) {
    if (!f) return;
    setFile(f); setDone(null); setError(null);
    if (!name) setName(f.name.replace(/\.glb$/i, ""));
    setCheck(await precheckGLB(await f.arrayBuffer()));
  }

  async function submit(e: Event) {
    e.preventDefault();
    if (!file) return;
    setError(null); setProgress(0);
    try {
      const asset = await uploadAsset(file, name.trim() || file.name, setProgress);
      setDone(asset);
      await refreshMyAssets();
    } catch (err) {
      setError(err instanceof ApiError ? describeError(err.code) : String(err));
    } finally {
      setProgress(null);
    }
  }

  return (
    <Panel title="上傳 GLB" onClose={() => $panel.set(null)}>
      <form onSubmit={submit} onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); void pick(e.dataTransfer?.files[0]); }}>
        <label>檔案（可拖放到此面板）</label>
        <input type="file" accept=".glb,model/gltf-binary" onChange={(e) => void pick((e.target as HTMLInputElement).files?.[0])} />
        <label>名稱</label>
        <input type="text" value={name} maxLength={80} onInput={(e) => setName((e.target as HTMLInputElement).value)} />
        {check && (
          <div class="hint">
            三角形 {check.triangles} · 貼圖 {check.textures} · 節點 {check.nodes}
            {check.problems.map((p) => <div class="error" key={p}>{p}</div>)}
          </div>
        )}
        <button type="submit" disabled={!file || !check?.ok || progress !== null}>
          {progress === null ? "上傳" : `上傳中 ${Math.round(progress * 100)}%`}
        </button>
        {error && <div class="error">{error}</div>}
        {done && (
          <div class="hint">
            完成。代碼：<code>{done.code}</code>
            <button type="button" class="secondary" onClick={() => void navigator.clipboard.writeText(done.code)}>複製</button>
          </div>
        )}
      </form>
    </Panel>
  );
}
